export default "__VITE_ASSET__DODpwFIP__"